import { api } from "@/lib/api";
import { Panel, Table, Pill, useLoad, Loading, statusTone } from "@/components/common";
import { MeetingTable } from "@/pages/Meetings";

export default function ProjectMeetings({ p }) {
  const m = useLoad(() => api.get(`/meetings?project_id=${p.id}`).then((r) => r.data), [p.id]);
  const a = useLoad(() => api.get(`/actions?project_id=${p.id}`).then((r) => r.data), [p.id]);
  if (!m.data) return <Loading error={m.error} />;
  return (
    <>
      <Panel title="Standing meeting series" testid="project-meetings"><MeetingTable rows={m.data} testid="project-meetings-table" /></Panel>
      <Panel title="Action log" testid="project-actions">
        <Table rows={a.data || []} empty="No actions" cols={[{ k: "title", h: "Action" }, { k: "owner_name", h: "Owner" }, { k: "due", h: "Due" }, { k: "status", h: "Status", r: (x) => <Pill tone={statusTone(x.status)}>{x.status}</Pill> }]} />
      </Panel>
    </>
  );
}
